module.exports = __webpack_public_path__ + "img/icon_goback.4b27497c.svg";